import React, { useEffect, useState } from 'react';
import banner1_1 from 'Assets/img/recruitment/banner1.png';
import banner1_2 from 'Assets/img/recruitment/banner1@2x.png';
import banner1_3 from 'Assets/img/recruitment/banner1@3x.png';
import banner2_1 from 'Assets/img/recruitment/banner2.png';
import banner2_2 from 'Assets/img/recruitment/banner2@2x.png';
import banner2_3 from 'Assets/img/recruitment/banner2@3x.png';
import banner3_1 from 'Assets/img/recruitment/banner3.png';
import banner3_2 from 'Assets/img/recruitment/banner3@2x.png';
import banner3_3 from 'Assets/img/recruitment/banner3@3x.png';
import icArrowWhite from 'Assets/img/recruitment/ic_arrow_white_36.png';
import icArrowWhite2 from 'Assets/img/recruitment/ic_arrow_white_36@2x.png';
import icArrowWhite3 from 'Assets/img/recruitment/ic_arrow_white_36@3x.png';
import dotWhite from 'Assets/img/recruitment/dot_white.png';
import dotWhite2 from 'Assets/img/recruitment/dot_white@2x.png';
import dotWhite3 from 'Assets/img/recruitment/dot_white@3x.png';
import dotGray from 'Assets/img/recruitment/dot_gray.png';
import dotGray2 from 'Assets/img/recruitment/dot_gray@2x.png';
import dotGray3 from 'Assets/img/recruitment/dot_gray@3x.png';

import { getImageSet } from 'Util/DataUtils';

const banner1 = getImageSet([banner1_1, banner1_2, banner1_3]);
const banner2 = getImageSet([banner2_1, banner2_2, banner2_3]);
const banner3 = getImageSet([banner3_1, banner3_2, banner3_3]);
const arrows = getImageSet([icArrowWhite, icArrowWhite2, icArrowWhite3]);
const dotsWhite = getImageSet([dotWhite, dotWhite2, dotWhite3]);
const dotsGray = getImageSet([dotGray, dotGray2, dotGray3]);

const LogoSection = () => {
  const [num, setNum] = useState(1);
  const [carouselTransition, setCarouselTransition] = useState('');
  const images = [banner1, banner2, banner3];
  const cloneImages = [images[images.length - 1], ...images, images[0]];
  const lastImage = cloneImages.length - 1;

  const handleOriginSlide = index => {
    setTimeout(() => {
      setNum(index);
      setCarouselTransition('');
    }, 500);
  };
  const handleSlide = direction => {
    direction === 'prev' ? setNum(num => num - 1) : setNum(num => num + 1);
    setCarouselTransition('transform 500ms ease-in-out');
  };

  useEffect(() => {
    if (num === lastImage) handleOriginSlide(1);
    else if (num === 0) handleOriginSlide(lastImage - 1);
  }, [cloneImages.length, lastImage, num]);

  return (
    <>
      <div
        className="banner-image"
        style={{
          transition: `${carouselTransition}`,
          transform: `translateX(-${num}00%)`,
        }}
      >
        {cloneImages.map((image, i) => (
          <img key={i} {...image} alt={`banner_${i}`} />
        ))}
      </div>
      <div className="banner-left" onClick={() => handleSlide('prev')}>
        <img {...arrows} alt="left" />
      </div>
      <div className="banner-right" onClick={() => handleSlide('next')}>
        <img {...arrows} alt="right" style={{ transform: 'rotate(180deg)' }} />
      </div>
      <div className="banner-indicator-wrapper">
        {images.map((_, i) => (
          <div className="banner-indicator" key={`dot_${i}`} onClick={() => setNum(i + 1)}>
            {num === i + 1 ? <img {...dotsWhite} alt="dot_white" /> : <img {...dotsGray} alt="dot_gray" />}
          </div>
        ))}
      </div>
    </>
  );
};

export default LogoSection;
